import { Request, Response } from "express"

import { getGeneral, putGeneral } from "#services/recipe/general"

export const getRecipeGeneral = async (req: Request, res: Response) => {
	const list = await getGeneral({
		id: req.params.recipeID,
	})

	res.json(list)
}

export const updateRecipeGeneral = async (req: Request, res: Response) => {
	const list = await putGeneral({
		id: req.params.id,
	})

	res.json(list)
}
